var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd" }, [
    _c("div", { staticClass: "container mt-5" }, [
      _c("h6", { staticClass: "font-weight-bold" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$resourceString[
                "myProject.Project.EditPage.Item.EditColorImage"
              ]
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wf-modal-button-close btn button-full",
          attrs: { type: "button" },
          on: {
            click: function() {
              _vm.hideModal("project-edit-colors-feature-img")
            }
          }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
            attrs: { "aria-label": "Close modal" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "my-project stepper-container row" }, [
          _c(
            "ul",
            { staticClass: "stepper d-flex justify-content-center" },
            _vm._l(Object.entries(_vm.stepHeaders), function(ref) {
              var stepIndex = ref[0]
              var header = ref[1]
              return _c(
                "li",
                { key: header, class: _vm.getClassName(stepIndex) },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$resourceString[header]) +
                      "\n          "
                  )
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _vm.getContentWizardData.step === 1
        ? _c("div", [_c("step-three")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.getContentWizardData.step === 2
        ? _c("div", [_c("step-four")], 1)
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer border-0 mx-4" }, [
      _c("div", { staticClass: "justify-content-between w-100  row" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            on: {
              click: function() {
                _vm.hideModal("project-edit-colors-feature-img")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                ) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("span", [
          this.getContentWizardData.step == 1
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    disabled: !this.getContentWizardData.step3.length > 0
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleNext($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.EditPage.SaveContinue.Button"
                        ]
                      ) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          this.getContentWizardData.step == 2
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.updateProjectItem($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$resourceString[
                          "myProject.Project.ShareProject.Save.label"
                        ]
                      ) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }